import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import { useDispatch, useSelector } from 'react-redux';

import { isModalActive, closeModal } from "../../store/slices/modal";

import useRefreshAuthToken from "../../hooks/auth/useRefreshAuthToken";
import useSignOut from "../../hooks/auth/useSignOut";

import { Icons } from "../../data/Assets";

import cookiesHelper from "../../helpers/cookies";

import { SVGIcon } from "../wrappers/SVGIcon";

const modalName = "TIMEOUT_MODAL";
const modalTitle = "Timeout";
const modalClass = "timeout";

ReactModal.setAppElement('#root');
const TimeoutModal = () => {
    const dispatch = useDispatch();

    const isModalVisible: boolean = useSelector(isModalActive(modalName));

    const [token, setToken] = useState<string | null>(cookiesHelper.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string));

    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [signoutTimer, setSignoutTimer] = useState<number>(300);

    const { mutate: refreshAuthToken } = useRefreshAuthToken();
    const { mutate: signOut } = useSignOut();

    const afterOpenModal = () => {
        setToken(cookiesHelper.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    };

    const onCloseModal = () => {
        const newToken = cookiesHelper.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
        if (newToken !== token) {
            setToken(newToken);
        }
        dispatch(closeModal(modalName));
    };

    const onStaySignedIn = () => {
        refreshAuthToken({
            setIsProcessing,
            setToken: setToken,
            onClose: () => dispatch(closeModal("TIMEOUT_MODAL")),
        });
    };

    useEffect(() => {
        if (isModalVisible) {
            const interval = setInterval(() => {
                setSignoutTimer((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [isModalVisible]); // eslint-disable-line

    useEffect(() => {
        if (signoutTimer <= 0) {
            dispatch(closeModal("MESSAGE_MODAL"));
            signOut();
        };
    }, [signoutTimer]); // eslint-disable-line

    useEffect(() => {
        if (isModalVisible) {
            setSignoutTimer(300);
        }
    }, [token]); // eslint-disable-line

    return (
        <ReactModal
            id={modalName}
            isOpen={isModalVisible}
            onAfterOpen={afterOpenModal}
            onRequestClose={onCloseModal}
            contentLabel={modalTitle}
            overlayClassName={`immersion__modal_overlay immersion__modal_overlay__${modalClass}`}
            className={`immersion__modal_dialog immersion__modal_dialog__${modalClass}`}
            shouldCloseOnEsc={false}
            shouldCloseOnOverlayClick={false}
        >
            <div className={`immersion__modal_content immersion__modal_content__${modalClass}`}>
                {/* <button className="immersion__modal_close_btn" onClick={onCloseModal}>
                    <BsX />
                </button> */}
                <div className="immersion__session_timeout_view">
                    <br />
                    <h4 className="immersion__color__dark">Session Timeout</h4>
                    <p className="immersion__color__dark_grey">
                        Your session is about to expire. Would you like to stay signed in?
                    </p>
                    <br />
                    <div className="immersion__session_timeout_warning_content">
                        <SVGIcon src={Icons.ExclamationTriangle} color="error" />
                        <p className="immersion__color__error">
                            You will be signed out in  {Math.floor(signoutTimer / 60)} minutes {(signoutTimer % 60).toString().padStart(2, '0')} seconds.
                        </p>
                    </div>
                    <br />
                    <div className="immersion__session_timeout_actions">
                        <button className="immersion__btn immersion__btn__secondary" onClick={() => signOut()}>Sign out</button>
                        <button
                            className={`immersion__btn immersion__btn__primary`}
                            onClick={onStaySignedIn}
                        >
                            {
                                isProcessing
                                    ? <i className='immersion__btn_loader' />
                                    : 'Stay Signed In'
                            }
                        </button>
                    </div>
                </div>
            </div>
        </ReactModal>
    );
};

export default TimeoutModal;